module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 subtitle"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._t("default")], 2)])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.notesTransactions.length === 0) ? _c('no-upcoming-transactions') : _c('div', _vm._l((_vm.notesTransactions), function(nt, index) {
    return _c('div', {
      key: index,
      staticClass: "panel panel-default"
    }, [_c('upcoming-transaction-data', {
      attrs: {
        "transaction-id": nt.transaction.transactionId,
        "header-message": _vm.headerMessage,
        "alert-message": _vm.getAlertMessage(nt),
        "maturity-date": nt.transaction.maturityDate,
        "note-id": nt.transaction.note.noteId,
        "payment-type": nt.transaction.type,
        "amount": nt.transaction.amount
      }
    }, [
      [(!_vm.actionProvided) ? _c('div', {
        staticClass: "alert alert-info",
        attrs: {
          "role": "alert"
        }
      }, [_c('p', [_c('em', {
        staticClass: "icon icon-info pr-sm"
      }), _vm._v(_vm._s(_vm.headerMessage) + "\n              "), _c('strong', [_vm._v(_vm._s(_vm.getAlertMessage(nt)))]), _vm._v(" on\n              " + _vm._s(_vm.formatDate(nt.transaction.maturityDate)) + ".\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Please note that you're able to change this payment using the\n              options below.\n            ")])]) : _c('div', {
        staticClass: "alert alert-success",
        attrs: {
          "role": "alert"
        }
      }, [_c('p', [_c('em', {
        staticClass: "icon-check pr-sm"
      }), _vm._v("You have chosen to\n              "), _c('strong', [_vm._v(_vm._s(_vm.getAlertMessage(nt)))]), _vm._v(" on\n              " + _vm._s(_vm.formatDate(nt.transaction.maturityDate)) + ".\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Please note that you're able to change this payment using the\n              options below.\n            ")])])]
    ], 2), _vm._v(" "), _c('div', {
      staticClass: "transaction-reinvest"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Select from options below")])]), _vm._v(" "), (_vm.isReinvestActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Rate and term")])]) : _vm._e(), _vm._v(" "), (_vm.isDonateActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Donation amount")])]) : _vm._e(), _vm._v(" "), (_vm.isCashoutActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Select bank account")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.action),
        expression: "nt.action"
      }],
      staticClass: "form-control input-lg",
      attrs: {
        "name": "action",
        "required": ""
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          nt.action = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.$emit('actionChanged', {
            action: nt.action,
            index: index,
            actionPreviousTaken: _vm.actionProvided,
          })
        }]
      }
    }, _vm._l((_vm.allowedActions), function(action, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": action
        }
      }, [_vm._v(_vm._s(action.text) + "\n              ")])
    }))]), _vm._v(" "), (_vm.isReinvestActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('CustomRatesAndTermsForInvestor', {
      attrs: {
        "nt": nt,
        "action-provided": _vm.actionProvided
      },
      on: {
        "setRateAndTerm": _vm.setRateAndTerm
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isDonateActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.amountForDonation),
        expression: "nt.amountForDonation"
      }],
      staticClass: "form-control input-lg",
      attrs: {
        "disabled": true,
        "required": ""
      },
      domProps: {
        "value": (nt.amountForDonation)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          nt.amountForDonation = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.isCashoutActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.fundingSource),
        expression: "nt.fundingSource"
      }],
      staticClass: "form-control input-lg",
      attrs: {
        "name": "fundingSource",
        "required": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          nt.fundingSource = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_vm._l((_vm.fundingSources), function(fs, index) {
      return (fs.removed) ? _c('option', {
        key: index,
        attrs: {
          "disabled": "",
          "hidden": ""
        },
        domProps: {
          "value": fs
        }
      }, [_vm._v(_vm._s(fs.name))]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.fundingSources), function(fs, index) {
      return (!fs.removed) ? _c('option', {
        key: index,
        domProps: {
          "value": fs
        }
      }, [_vm._v(_vm._s(fs.name))]) : _vm._e()
    })], 2), _vm._v(" "), (_vm.shouldSubmitButtonBeDisabled(nt)) ? _c('span', {
      staticClass: "error-feedback"
    }, [_vm._v("Please choose a bank account above or add one on the\n              "), _c('router-link', {
      staticClass: "hyperlink",
      attrs: {
        "to": {
          name: 'AddFundingSource'
        },
        "title": "Add a bank account",
        "replace": ""
      }
    }, [_vm._v("bank account page")])], 1) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.isReinvestActionTaken(nt.action)) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "checkbox c-checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.termsOfConditionAcceptance),
        expression: "nt.termsOfConditionAcceptance"
      }],
      attrs: {
        "type": "checkbox",
        "value": ""
      },
      domProps: {
        "checked": Array.isArray(nt.termsOfConditionAcceptance) ? _vm._i(nt.termsOfConditionAcceptance, "") > -1 : (nt.termsOfConditionAcceptance)
      },
      on: {
        "__c": function($event) {
          var $$a = nt.termsOfConditionAcceptance,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (nt.termsOfConditionAcceptance = $$a.concat($$v))
            } else {
              $$i > -1 && (nt.termsOfConditionAcceptance = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            nt.termsOfConditionAcceptance = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "fa fa-check"
    }), _vm._v(" "), _c('terms-of-conditions', {
      attrs: {
        "hide-state-disclosures": ""
      }
    })], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('button', {
      staticClass: "btn btn-default btn-lg",
      attrs: {
        "type": "submit",
        "disabled": _vm.submitsDisabled || _vm.shouldSubmitButtonBeDisabled(nt)
      },
      on: {
        "click": function($event) {
          _vm.$emit('submit', nt, _vm.rateAndTerm)
        }
      }
    }, [_vm._v("\n            Submit\n          ")])])])], 1)
  }))], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "line-separator bottom-margin"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42320436","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UpcomingTransactions/index.vue
// module id = 2142
// module chunks = 1